import React from "react";
import LeadTable from "./components/LeadTable";
import FilterSidebar from "./components/FilterSidebar";

export default function LeadExplorer() {
  return (
    <div className="flex h-screen bg-slate-50 overflow-hidden font-sans">
      <div className="w-80 bg-white border-r border-slate-200 flex flex-col h-full shrink-0 shadow-sm z-10">
        <FilterSidebar />
      </div>

      <div className="flex-1 p-6 flex flex-col min-w-0 overflow-hidden">
        <div className="flex items-center justify-between mb-6 shrink-0">
          <div>
            <h2 className="text-2xl font-bold text-slate-900">Lead Explorer</h2>
            <p className="text-sm text-slate-500 mt-1">
              Found <strong className="text-slate-900 font-semibold">1,248</strong> potential matches.
            </p>
          </div>
          <div className="flex items-center gap-3">
            <button className="px-4 py-2 border border-slate-300 rounded-lg text-sm font-semibold text-slate-700 bg-white hover:bg-slate-50 shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-slate-200">
              Save to List
            </button>
            <button className="px-4 py-2 bg-brand-700 text-white rounded-lg text-sm font-semibold hover:bg-brand-800 shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-1">
              Email Leads
            </button>
          </div>
        </div>

        <div className="flex-1 min-h-0 drop-shadow-sm">
          <LeadTable />
        </div>
      </div>
    </div>
  );
}